import React, {  } from 'react'
import api, { MetadataOption } from 'api'
import {AppFormItemEnum} from './index'
import {AppFormItemInput,AppFormItemRadio,AppFormItemSelect,AppFormItemText,AppFormItemLabel} from '../AppFormItem'
import './index.less'

export interface AppFormItemProps{
	keyName?:string
	label?: string
	labelHidden?:boolean
	field?:string
	value?:string
	textKeyName?:string
	text?:string
	textField?: string
	itemType?: string  // AppFormItemEnum 如果有render,则直接取render 增加隐藏域类型，作为属性储存
	render?:()=>JSX.Element | string

	onFormItemChange?:(formData?:any)=>void
	
	colSpan?: number
	
	errorTips?: string   // 校验后错误提示信息
	hidden?: boolean  
	unSave?: boolean
	textSave?: boolean
	req?: boolean
	maxLength?: number     // 字段最大长度，input textarea类型有效
	maxNumber?: number     //  input number 类型有效，可输入的最大值
	minNumber?: number     //  input number 类型有效，可输入的最小值
	unRepeat?: boolean    // 是否校验重复，启用系统的自动保存方法时生效
	scopeField?: string // 校验字段重复的数据范围字段，比如项目ID，公司ID 
	sectionKey?:number

	dataType?:string
	readonly?: boolean
	format?: string
	password?:boolean

	// 以下是每个item类型需要的props
    prefix?: string
    unit?: string
	placeholder?: string
	forbidChars?: string

	renderOptions?: () => Promise<MetadataOption[]>  // 参数配置，后台取数
	options?: MetadataOption[]

	textHeight?:number

	
}

export  class AppFormItem extends React.Component<AppFormItemProps>{
	state = {loadOptions:false,options: [] as MetadataOption[]}

	async componentDidMount(){
		if(this.props.renderOptions){
			let options = await this.props.renderOptions();
			this.setState({loadOptions:true,options})
		}
		
	}

	renderItem = () =>{
		let itemProps = {...this.props}
		if(this.props.renderOptions){
			let {loadOptions,options} = this.state;
			if(loadOptions) {
				itemProps = {...this.props,options}
			}else{
				return null;
			}
		}
		let {itemType,readonly} = itemProps;
		if(itemProps.render){
			return itemProps.render();
		}
		if(readonly){
			return <AppFormItemLabel key={itemProps.value} {...itemProps} />;
		}
		switch (itemType){
			case AppFormItemEnum.input:
				return <AppFormItemInput {...itemProps}/>
			case AppFormItemEnum.radio:
				return <AppFormItemRadio {...itemProps}/>
			case AppFormItemEnum.select:
				return <AppFormItemSelect {...itemProps}/>
			case AppFormItemEnum.text:
				return <AppFormItemText {...itemProps}/>
			case AppFormItemEnum.search:
				return <AppFormItemSelect {...itemProps}/>
		}
		return  <AppFormItemLabel key={itemProps.value} {...itemProps} />;
	}

	render(){
		return this.renderItem();
	}
}


// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppFormItem.tsx